import { render, staticRenderFns } from "./MVBox.vue?vue&type=template&id=440c2edc"
import script from "./MVBox.vue?vue&type=script&lang=js"
export * from "./MVBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports